import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "layoutType", "title", "description", "manager", "card", "benefits", "withoutBenefits", "className", "onGetConsultationClick"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { useMemo } from 'react';
import { CloudMoveSVG, HeadphonesSVG, UsersSVG } from '@sbercloud/uikit-product-icons';
import { useLocale } from '@sbercloud/uikit-product-locale';
import { CardBasic } from '@sbercloud/uikit-product-site-cards';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { ButtonFilled } from '@snack-uikit/button';
import { Typography } from '@snack-uikit/typography';
import { SectionBasic } from '../SectionBasic';
import styles from "./styles.module.css";
import { getCardTitleTypographyProps } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SectionPersonalManager(_ref) {
  var id = _ref.id,
    layoutType = _ref.layoutType,
    title = _ref.title,
    description = _ref.description,
    manager = _ref.manager,
    card = _ref.card,
    benefits = _ref.benefits,
    withoutBenefits = _ref.withoutBenefits,
    className = _ref.className,
    onGetConsultationClick = _ref.onGetConsultationClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useLocale = useLocale('SiteSection'),
    t = _useLocale.t;
  var benefitsCards = useMemo(function () {
    if (benefits) {
      return benefits;
    }
    return [{
      title: t('PersonalManager.argumentAmountOfExperts'),
      icon: UsersSVG
    }, {
      title: t('PersonalManager.argumentMethodologies'),
      icon: CloudMoveSVG
    }, {
      title: t('PersonalManager.argumentPersonalManager'),
      icon: HeadphonesSVG
    }];
  }, [benefits, t]);
  return /*#__PURE__*/_jsxs(SectionBasic, _objectSpread(_objectSpread({
    id: id,
    title: title || t('PersonalManager.title'),
    description: description || t('PersonalManager.subtitle'),
    backgroundColor: "neutral-background1-level",
    layoutType: layoutType,
    className: cn(className, styles.sectionPersonalManager)
  }, extractSupportProps(rest)), {}, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.content,
      "data-layout-type": layoutType,
      children: [/*#__PURE__*/_jsxs("div", {
        className: cn(styles.card, styles.leftSide),
        "data-layout-type": layoutType,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.approachTextWrapper,
          "data-layout-type": layoutType,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.cardTextContent,
            children: [/*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
              family: "sans"
            }, getCardTitleTypographyProps(layoutType)), {}, {
              children: manager.title || t('PersonalManager.individualApproachTitle')
            })), /*#__PURE__*/_jsx(Typography, {
              family: "sans",
              purpose: "body",
              size: "l",
              className: styles.cardDescription,
              children: manager.text || t('PersonalManager.individualApproachDescription')
            })]
          }), /*#__PURE__*/_jsx(ButtonFilled, {
            className: styles.consultationButton,
            size: "l",
            appearance: "primary",
            label: t('PersonalManager.consultationButton'),
            onClick: onGetConsultationClick,
            "data-layout-type": layoutType,
            "data-test-id": "personal-manager_get-consultation-button"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.imageWrapper,
          "data-layout-type": layoutType,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.imageBackground
          }), /*#__PURE__*/_jsx("img", {
            src: manager.img,
            alt: "personal_manager",
            className: styles.approachManager,
            "data-layout-type": layoutType
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: cn(styles.card, styles.cardTextContent, styles.rightSide),
        "data-layout-type": layoutType,
        children: [/*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
          family: "sans"
        }, getCardTitleTypographyProps(layoutType)), {}, {
          children: (card === null || card === void 0 ? void 0 : card.title) || t('PersonalManager.allDaySupportTitle')
        })), /*#__PURE__*/_jsx(Typography, {
          family: "sans",
          purpose: "body",
          size: "l",
          className: styles.cardDescription,
          children: (card === null || card === void 0 ? void 0 : card.text) || t('PersonalManager.allDaySupportDescription')
        })]
      })]
    }), !withoutBenefits && /*#__PURE__*/_jsx("div", {
      className: styles.expertiseCards,
      "data-layout-type": layoutType,
      children: benefitsCards === null || benefitsCards === void 0 ? void 0 : benefitsCards.map(function (card) {
        return /*#__PURE__*/_jsx(CardBasic, {
          title: card.title,
          icon: card.icon,
          layoutType: layoutType
        }, card.title);
      })
    })]
  }));
}